var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolutionsCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 123,
    viewBox: "0 0 122 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12075_28986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.6693 15H62.3303L59.1777 28.1246H62.3303H67.6693H70.8218L67.6693 15Z",
    fill: "#00A3E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9493 62.1434C73.9493 62.5969 73.5944 63 73.0873 63H56.862C56.3549 63 56 62.5969 56 62.1434V37.8566C56 37.4031 56.3549 37 56.862 37H73.138C73.5944 37 74 37.3527 74 37.8566V62.1434H73.9493Z",
    fill: "#00A3E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9519 34.5143C71.9519 34.7714 71.6151 35 71.134 35H58.8179C58.3849 35 58 34.8 58 34.5143V31.4857C58.0481 31.2286 58.3849 31 58.8179 31H71.1821C71.6151 31 72 31.2 72 31.4857V34.5143H71.9519Z",
    fill: "#00A3E0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12075_28986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.3616 74.3203L98.5206 40.843L94.7003 39.5689L84.4591 70.2947H47.1051L33.0154 28.0254H21.5V32.051H30.1129L43.4981 72.2028L34.5048 92.4357H89.936V88.4101H40.7003L46.9622 74.3203H87.3616Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6917 102.5C53.915 102.5 55.7173 100.697 55.7173 98.4739C55.7173 96.2506 53.915 94.4482 51.6917 94.4482C49.4684 94.4482 47.666 96.2506 47.666 98.4739C47.666 100.697 49.4684 102.5 51.6917 102.5Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.846 102.5C78.0693 102.5 79.8716 100.697 79.8716 98.4739C79.8716 96.2506 78.0693 94.4482 75.846 94.4482C73.6227 94.4482 71.8203 96.2506 71.8203 98.4739C71.8203 100.697 73.6227 102.5 75.846 102.5Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12075_28986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 48,
    fill: "white",
    transform: "translate(56 15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12075_28986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(0.5 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionsCart);
export default __webpack_public_path__ + "static/media/solutions-cart.fe72c10d67d3c7f3f817a6178336f903.svg";
export { ForwardRef as ReactComponent };